var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n      }\n\n      .cls-2 {\n        stroke: #414248;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7.45325 9.61301V16.6609H16.548V9.61301"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.3158 10.4083L12.0002 6.42969L17.6845 10.4083"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.7059 16.6609V13.2505C13.7059 12.6229 13.197 12.114 12.5694 12.114H11.4329C10.8064 12.1157 10.2994 12.624 10.2994 13.2505V16.6609"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.0034 7.99832C20.0034 6.34077 21.3472 4.99707 23.0047 4.99707C21.3472 4.99707 20.0034 3.65336 20.0034 1.99582C20.0034 3.65336 18.6597 4.99707 17.0022 4.99707C18.6597 4.99707 20.0034 6.34077 20.0034 7.99832Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.0038 12V16.0017C21.0038 18.7642 18.7643 21.0037 16.0018 21.0037H7.99842C5.23585 21.0037 2.99634 18.7642 2.99634 16.0017V7.99833C2.99634 5.23576 5.23585 2.99625 7.99842 2.99625H14.0009"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.6e55b3866033d0dd2405b230fca86be8.svg";
export { ForwardRef as ReactComponent };